const ContactPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-amber-50 py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl font-bold text-gray-800 mb-6">Contact Us</h1>
            <p className="text-xl text-gray-600">
              Have questions or ready to get started? We're here to help.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="flex flex-col md:flex-row gap-8">
              <div className="md:w-1/3">
                <div className="bg-white p-6 rounded-lg shadow-md h-full">
                  <h2 className="text-2xl font-bold text-gray-800 mb-6">Get in Touch</h2>

                  <div className="space-y-6">
                    <div>
                      <h3 className="text-lg font-semibold text-gray-800 mb-2">Our Office</h3>
                      <address className="not-italic text-gray-600">
                        <p>14/3, Whitefield main road</p>
                        <p>Katamnallur</p>
                        <p>Bangalore</p>
                      </address>
                    </div>

                    <div>
                      <h3 className="text-lg font-semibold text-gray-800 mb-2">Contact Info</h3>
                      <p className="text-gray-600">info@techapplics.com</p>
                      <p className="text-gray-600">973895</p>
                    </div>

                    {/* <div>
                      <h3 className="text-lg font-semibold text-gray-800 mb-2">Business Hours</h3>
                      <p className="text-gray-600">Monday - Friday: 9am - 6pm</p>
                      <p className="text-gray-600">Saturday - Sunday: Closed</p>
                    </div> */}
                  </div>
                </div>
              </div>

              <div className="md:w-2/3">
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h2 className="text-2xl font-bold text-gray-800 mb-6">Send Us a Message</h2>

                  <form className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label htmlFor="name" className="block text-gray-700 mb-2">Your Name</label>
                        <input
                          type="text"
                          id="name"
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-200"
                          placeholder="John Doe"
                        />
                      </div>

                      <div>
                        <label htmlFor="email" className="block text-gray-700 mb-2">Email Address</label>
                        <input
                          type="email"
                          id="email"
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-200"
                          placeholder="john@example.com"
                        />
                      </div>
                    </div>

                    <div>
                      <label htmlFor="subject" className="block text-gray-700 mb-2">Subject</label>
                      <input
                        type="text"
                        id="subject"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-200"
                        placeholder="How can we help you?"
                      />
                    </div>

                    <div>
                      <label htmlFor="message" className="block text-gray-700 mb-2">Message</label>
                      <textarea
                        id="message"
                        rows="5"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-200"
                        placeholder="Your message here..."
                      ></textarea>
                    </div>

                    <div>
                      <button
                        type="submit"
                        className="bg-gray-800 text-white px-6 py-3 rounded-md font-medium hover:bg-gray-700 transition-colors"
                      >
                        Send Message
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      {/* Map Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Our Location</h2>
          <div className="max-w-5xl mx-auto">
            <div className="bg-white p-4 rounded-lg shadow-md">
              <iframe
                title="Techapplics Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7773.466137268828!2d77.75009013566786!3d13.052655450761574!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae0fe540019c03%3A0xb90539e16ce2dffa!2sKatamnallur%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1747678005723!5m2!1sen!2sin"
                width="100%"
                height="100%"
                className="w-full h-96 border-0 rounded-md"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>


      {/* FAQ Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-3xl mx-auto">
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">What industries do you specialize in?</h3>
                <p className="text-gray-600">
                  We specialize in technology sectors including software development, IT infrastructure, data science, cybersecurity, and more. Our team has experience working with clients across various industries.
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">How long does the recruitment process typically take?</h3>
                <p className="text-gray-600">
                  The timeline varies depending on the role and requirements, but we typically present qualified candidates within 2-3 weeks. Our goal is to balance speed with thoroughness to ensure the right fit.
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Do you offer remote development services?</h3>
                <p className="text-gray-600">
                  Yes, we have a global team of developers who can work remotely on your projects. We use collaborative tools and established processes to ensure effective communication and project management.
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">What technologies do you work with?</h3>
                <p className="text-gray-600">
                  Our development team is proficient in a wide range of technologies including React, Angular, Node.js, Python, Java, .NET, and more. We stay updated with the latest tech trends to provide cutting-edge solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;